import { configureStore } from '@reduxjs/toolkit';
import authReducer from './redux/authSlice';
import doctorReducer from './redux/doctorSlice';
import patientReducer from './redux/patientSlice';
import appointmentReducer from './redux/appointmentSlice';
import blockingReducer from "./redux/blockingSlice";
import adminReducer from './redux/adminSlice';
import tenantReducer from './redux/tenantSlice';
import dashboardReducer from './redux/dashboardSlice';
import reportsReducer from './redux/reportsSlice';
import rulesReducer from './redux/rulesSlice';
import masterReducer from './redux/masterSlice';
import translationReducer from './redux/translationSlice';
import customPriceReducer from './redux/customPriceSlice';
import ctgReducer from './redux/ctgSlice';
import featureReducer from './redux/featureSlice';
import medicineReducer from './redux/medicineSlice';
import prescriptionFieldReducer from './redux/prescriptionFieldSlice';
import paymentReducer from './redux/paymentSlice';
import subscriptionReducer from './redux/subscriptionSlice';
import contactInquiryReducer from './redux/contactInquirySlice';
import familyReducer from './redux/familySlice';
import staffReducer from './redux/staffSlice';
import pharmacyReducer from './redux/pharmacySlice';
import labReducer from './redux/labSlice';
import radiologyReducer from './redux/radiologySlice';
import masterCatalogReducer from './redux/masterCatalogSlice';
import chatThreadReducer from './redux/chatThreadSlice';
import mocLinkReducer from './redux/mocLinkSlice';
import calendarEventsReducer from './redux/calendarEventsSlice';
import healthRecordReducer from './redux/healthRecordSlice';
import appointmentShareReducer from './redux/appointmentShareSlice';
import appointmentDraftReducer from './redux/appointmentDraftSlice';
import checkSetReducer from './redux/checkSetSlice';
import programmeReducer from './redux/programmeSlice';

// The reducer map, named so tests can build a FRESH store per test instead of
// sharing the singleton below — one test's dispatch must not decide another
// test's initial state. Nothing in the app should import this; import `store`.
export const rootReducer = {
  auth: authReducer,
  doctor: doctorReducer,
  patient: patientReducer,
  appointment: appointmentReducer,
  blocking: blockingReducer,
  admin: adminReducer,
  tenant: tenantReducer,
  dashboard: dashboardReducer,
  reports: reportsReducer,
  rules: rulesReducer,
  master: masterReducer,
  translation: translationReducer,
  customPrice: customPriceReducer,
  ctg: ctgReducer,
  feature: featureReducer,
  medicine: medicineReducer,
  prescriptionField: prescriptionFieldReducer,
  payment: paymentReducer,
  subscription: subscriptionReducer,
  contactInquiry: contactInquiryReducer,
  family: familyReducer,
  staff: staffReducer,
  pharmacy: pharmacyReducer,
  lab: labReducer,
  radiology: radiologyReducer,
  masterCatalog: masterCatalogReducer,
  chatThreads: chatThreadReducer,
  mocLink: mocLinkReducer,
  calendarEvents: calendarEventsReducer,
  healthRecord: healthRecordReducer,
  appointmentShare: appointmentShareReducer,
  appointmentDraft: appointmentDraftReducer,
  checkSets: checkSetReducer,
  programmes: programmeReducer,
};

export const store = configureStore({ reducer: rootReducer });
